import {
  AgentAppointments,
  AgentPortfolio,
  allRegisteredAgents,
  ContactQueries,
  LeadDetails,
  MarketedPropertyListing,
  MessagesList,
  MLSProperty,
  MlsPropertyDetails,
  OffMarketProperty,
  Pagination,
  PayrollSubmissions,
  PropertyForm,
  PropertyMapItem,
  PropertySearch,
  SendMessageRequest,
  Tickets,
  tweets,
  UserBlogs,
  UserDetails,
  UserProperties,
  UserScheduledTour,
  youtube,
  RentalListing,
} from 'src/app/shared/models';
import { UserState } from './state';
import {
  MemoizedSelector,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
export const selectUserState: MemoizedSelector<object, UserState> =
  createFeatureSelector<UserState>('user');

const getUserIsLoading = (state: UserState): boolean => state.isLoading;
const agentRegisteriingLoading = (state: UserState): boolean => state.isLoading;
const getUserDetails = (state: UserState): UserDetails =>
  state.details as UserDetails;
const getUserIsDeactivating = (state: UserState): boolean =>
  state.isDeactivating;
const getUserProperties = (state: UserState): MarketedPropertyListing[] =>
  state.properties;
const getUserWishList = (state: UserState): any[] => state.wishList;
const getAddedPropertyInWishList = (state: UserState): any[] =>
  state.addedPropertyInwishList;
const getUserPropertyDetails = (state: UserState): MarketedPropertyListing =>
  state.userPropertyDetails as MarketedPropertyListing;
const getUserTickets = (state: UserState): Tickets[] => state.tickets;
const getUserTicketDetails = (state: UserState): Tickets =>
  state.ticketDetails as Tickets;
const getAgentLeads = (state: UserState): LeadDetails[] => state.agentLeads;
const getMarketedAgentLeads = (state: UserState): LeadDetails[] => state.marketedAgentLeads;
const getMLSProperties = (state: UserState): MLSProperty[] =>
  state.mlsProperties.list as MLSProperty[];
const getMLSMapProperties = (state: UserState): PropertyMapItem[] =>
  state.mlsProperties.mlsMapProperties;
const getMLSPropertyDetails = (state: UserState): MlsPropertyDetails =>
  state.mlsProperties.details as MlsPropertyDetails;
const getMLSSearchQuery = (state: UserState): PropertySearch =>
  state.mlsProperties.query as PropertySearch;
const getAgentAppointments = (state: UserState): AgentAppointments[] =>
  state.agentAppointments;
const getUserScheduledTours = (state: UserState): UserScheduledTour[] =>
  state.scheduledTours;

const getBlogs = (state: UserState): UserBlogs[] => state.blogs;
const getUserBlogDetails = (state: UserState): UserBlogs =>
  state.blogDetails as UserBlogs;

const getAllRegisterAgents = (state: UserState): allRegisteredAgents[] =>
  state.allAgents;
const getAgentDetails = (state: UserState): allRegisteredAgents =>
  state.agentDetails as allRegisteredAgents;

const getUserMessages = (state: UserState): SendMessageRequest[] =>
  state.messages;
const getUserMessagesList = (state: UserState): MessagesList[] =>
  state.messagesList;
const getMessagedUserDetails = (state: UserState): UserDetails =>
  state.messagedUserDetails as UserDetails;

const getYoutubeVideos = (state: UserState): youtube[] => state.youtubeVideos;
const getTweets = (state: UserState): tweets => state.tweets as tweets;
const getInstagramPosts = (state: UserState): any => state.instagramPosts;

const getPaginationData = (state: UserState): Pagination =>
  state.pagination as Pagination;

const getAgentContactQueries = (state: UserState): ContactQueries[] =>
  state.contactQueries;

const getAgentPortfolio = (state: UserState): AgentPortfolio =>
  state.agentPortfolio as AgentPortfolio;

const getAgentPayrollSubmissions = (
  state: UserState,
): PayrollSubmissions[] | null => state.payrollSubmissions;

const getAgentPayrollSubmissionDetails = (
  state: UserState,
): PayrollSubmissions | null => state.payrollSubmissionDetails;

const getAgentOffMarketProperties = (
  state: UserState,
): OffMarketProperty[] | null => state.offMarketProperties.list;

const getAgentOffMarketPropertyDetails = (
  state: UserState,
): OffMarketProperty | null => state.offMarketProperties.details;

const getRentalListings = (state: UserState): RentalListing[] | null =>
  state.rentalListings;

const getRentalListingById = (state: UserState): RentalListing | null =>
  state.rentalListingById;

const getRentalSearchResults = (state: UserState): RentalListing[] | null =>
  state.rentalSearchResults;

const getRentalMapMarkers = (state: UserState): any[] | null =>
  state.rentalMapMarkers;

const getMarketedProperties = (
  state: UserState,
): MarketedPropertyListing[] | null => state.arisMarketedProperties.list;

const getMarketedPropertyDetails = (
  state: UserState,
): MarketedPropertyListing | null =>
  state.arisMarketedProperties.details as MarketedPropertyListing;

const getMarketedMapProperties = (
  state: UserState,
): MarketedPropertyListing[] | null =>
  state.arisMarketedProperties.mapProperties;

const getIsKycPolling = (state: UserState): boolean => state.isKycPolling;

const getIsKycPollingTimedOut = (state: UserState): boolean =>
  state.isKycPollingTimedOut;

const getPendingRentalSubmitAfterKycId = (state: UserState): number | null =>
  state.pendingRentalSubmitAfterKycId;

export const selectUserIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectUserState, getUserIsLoading);
export const selectAgentRegistringIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectUserState, agentRegisteriingLoading);
export const selectUserDetails: MemoizedSelector<object, UserDetails> =
  createSelector(selectUserState, getUserDetails);
export const selectUserIsDeactivating: MemoizedSelector<object, boolean> =
  createSelector(selectUserState, getUserIsDeactivating);
export const selectUserProperties: MemoizedSelector<
  object,
  MarketedPropertyListing[]
> = createSelector(selectUserState, getUserProperties);
export const selectUserWishList: MemoizedSelector<object, any[]> =
  createSelector(selectUserState, getUserWishList);
export const selectUserAddedPropertyInWishList: MemoizedSelector<
  object,
  any[]
> = createSelector(selectUserState, getAddedPropertyInWishList);
export const selectUserPropertyDetails: MemoizedSelector<
  object,
  MarketedPropertyListing
> = createSelector(selectUserState, getUserPropertyDetails);
export const selectUserTickets: MemoizedSelector<object, Tickets[]> =
  createSelector(selectUserState, getUserTickets);
export const selectUserTicketDetails: MemoizedSelector<object, Tickets> =
  createSelector(selectUserState, getUserTicketDetails);
export const selectAgentLeads: MemoizedSelector<object, LeadDetails[]> =
  createSelector(selectUserState, getAgentLeads);
export const selectMarketedAgentLeads: MemoizedSelector<object, LeadDetails[]> =
  createSelector(selectUserState, getMarketedAgentLeads);
export const selectMLSProperties: MemoizedSelector<object, MLSProperty[]> =
  createSelector(selectUserState, getMLSProperties);
export const selectMLSMapProperties: MemoizedSelector<
  object,
  PropertyMapItem[]
> = createSelector(selectUserState, getMLSMapProperties);
export const selectMLSPropertyDetails: MemoizedSelector<
  object,
  MlsPropertyDetails
> = createSelector(selectUserState, getMLSPropertyDetails);
export const selectMLSSearchQuery: MemoizedSelector<object, PropertySearch> =
  createSelector(selectUserState, getMLSSearchQuery);
export const selectAgentAppointments: MemoizedSelector<
  object,
  AgentAppointments[]
> = createSelector(selectUserState, getAgentAppointments);
export const selectUserScheduledTours: MemoizedSelector<
  object,
  UserScheduledTour[]
> = createSelector(selectUserState, getUserScheduledTours);

export const selectUserMessages: MemoizedSelector<
  object,
  SendMessageRequest[]
> = createSelector(selectUserState, getUserMessages);

export const selectUserMessagesList: MemoizedSelector<object, MessagesList[]> =
  createSelector(selectUserState, getUserMessagesList);

export const selectMessagedUserDetails: MemoizedSelector<object, UserDetails> =
  createSelector(selectUserState, getMessagedUserDetails);

export const selectUserBlogs: MemoizedSelector<object, UserBlogs[]> =
  createSelector(selectUserState, getBlogs);

export const selectUserBlogDetails: MemoizedSelector<object, UserBlogs> =
  createSelector(selectUserState, getUserBlogDetails);

export const selectPaginationData: MemoizedSelector<object, Pagination> =
  createSelector(selectUserState, getPaginationData);

export const selectAllRegisterAgents: MemoizedSelector<
  object,
  allRegisteredAgents[]
> = createSelector(selectUserState, getAllRegisterAgents);

export const selectAgentDetails: MemoizedSelector<object, allRegisteredAgents> =
  createSelector(selectUserState, getAgentDetails);

export const selectYoutubeVideos: MemoizedSelector<object, youtube[]> =
  createSelector(selectUserState, getYoutubeVideos);

export const selectTweets: MemoizedSelector<object, tweets> = createSelector(
  selectUserState,
  getTweets,
);

export const selectInstagramPosts: MemoizedSelector<object, any> =
  createSelector(selectUserState, getInstagramPosts);

export const selectAgentContactQueries: MemoizedSelector<
  object,
  ContactQueries[]
> = createSelector(selectUserState, getAgentContactQueries);

export const selectAgentPortfolio: MemoizedSelector<object, AgentPortfolio> =
  createSelector(selectUserState, getAgentPortfolio);

export const selectAgentPayrollSubmissions: MemoizedSelector<
  object,
  PayrollSubmissions[] | null
> = createSelector(selectUserState, getAgentPayrollSubmissions);

export const selectAgentPayrollSubmissionDetails: MemoizedSelector<
  object,
  PayrollSubmissions | null
> = createSelector(selectUserState, getAgentPayrollSubmissionDetails);

export const selectAgentOffMarketProperties: MemoizedSelector<
  object,
  OffMarketProperty[] | null
> = createSelector(selectUserState, getAgentOffMarketProperties);

export const selectAgentOffMarketPropertyDetails: MemoizedSelector<
  object,
  OffMarketProperty | null
> = createSelector(selectUserState, getAgentOffMarketPropertyDetails);

export const selectRentalListings: MemoizedSelector<
  object,
  RentalListing[] | null
> = createSelector(selectUserState, getRentalListings);

export const selectRentalListingById: MemoizedSelector<
  object,
  RentalListing | null
> = createSelector(selectUserState, getRentalListingById);

export const selectRentalSearchResults: MemoizedSelector<
  object,
  RentalListing[] | null
> = createSelector(selectUserState, getRentalSearchResults);

export const selectRentalMapMarkers: MemoizedSelector<object, any[] | null> =
  createSelector(selectUserState, getRentalMapMarkers);

export const selectArisMarketedProperties: MemoizedSelector<
  object,
  MarketedPropertyListing[] | null
> = createSelector(selectUserState, getMarketedProperties);

export const selectArisMarketedMapProperties: MemoizedSelector<
  object,
  MarketedPropertyListing[] | null
> = createSelector(selectUserState, getMarketedMapProperties);

export const selectArisMarketedPropertyDetails: MemoizedSelector<
  object,
  MarketedPropertyListing | null
> = createSelector(selectUserState, getMarketedPropertyDetails);

export const selectIsKycPolling: MemoizedSelector<object, boolean> =
  createSelector(selectUserState, getIsKycPolling);

export const selectIsKycPollingTimedOut: MemoizedSelector<object, boolean> =
  createSelector(selectUserState, getIsKycPollingTimedOut);

export const selectPendingRentalSubmitAfterKycId: MemoizedSelector<
  object,
  number | null
> = createSelector(selectUserState, getPendingRentalSubmitAfterKycId);
